document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[class*="expert-slider-"]');

  sliders.forEach((slider) => {
    const sectionClass = [...slider.classList].find(cls => cls.startsWith('expert-slider-'));
    if (!sectionClass) return;

    const sectionId = sectionClass.replace('expert-slider-', '');
    const container = slider.closest('.expert-container');
    if (!container) return;

    const nextBtn = container.querySelector(`.next-btn-${sectionId}`);
    const prevBtn = container.querySelector(`.prev-btn-${sectionId}`);
    const dotContainer = container.querySelector('.slider-dots');
    const cards = slider.querySelectorAll('.expert-card');

    if (!nextBtn || !prevBtn || !dotContainer || cards.length === 0) return;

    // TARGET TOTAL DOTS FIXED TO EXACTLY 4
    const TARGET_DOTS_COUNT = 4;

    // 1. Build exactly 4 dynamic dots
    dotContainer.innerHTML = '';
    for (let i = 0; i < TARGET_DOTS_COUNT; i++) {
      const dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('data-index', i);
      dotContainer.appendChild(dot);
    }

    const dots = dotContainer.querySelectorAll('span');

    // Calculate width variables dynamically
    const getScrollStep = () => {
      const firstCard = cards[0];
      const gap = parseFloat(window.getComputedStyle(slider).gap) || 18;
      return firstCard.offsetWidth + gap;
    };

    const getMaxScroll = () => {
      return slider.scrollWidth - slider.clientWidth;
    };

    // 2. Click events for standard side-arrows
    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    // 3. Mapping dot steps proportionally to match 4 discrete stops
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-index'), 10);
        const maxScrollableWidth = getMaxScroll();
        
        // Maps indices (0, 1, 2, 3) cleanly across total available tracking distance
        const targetScrollPosition = (index / (TARGET_DOTS_COUNT - 1)) * maxScrollableWidth;
        
        slider.scrollTo({
          left: targetScrollPosition,
          behavior: 'smooth'
        });
      });
    });

    // 4. Interface tracking calculations
    const updateUI = () => {
      const scrollLeft = slider.scrollLeft;
      const maxScrollableWidth = getMaxScroll();

      if (maxScrollableWidth <= 0) return;

      // Calculate the normalized ratio of how far the track has scrolled (0 to 1)
      const scrollRatio = scrollLeft / maxScrollableWidth;
      
      // Convert ratio back into an integer index between 0 and 3
      let activeIndex = Math.round(scrollRatio * (TARGET_DOTS_COUNT - 1));
      
      // Fallback clamping bounds safely
      activeIndex = Math.max(0, Math.min(activeIndex, TARGET_DOTS_COUNT - 1));

      dots.forEach((dot, idx) => {
        if (idx === activeIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });

      // Update native visibility states for control arrows
      prevBtn.style.opacity = scrollLeft <= 4 ? '0.35' : '1';
      nextBtn.style.opacity = scrollLeft >= maxScrollableWidth - 4 ? '0.35' : '1';
    };

    slider.addEventListener('scroll', updateUI, { passive: true });
    window.addEventListener('resize', updateUI, { passive: true });
    
    // Fire checking routines on paint
    updateUI();
  });
});